// redux/report/reportReducer.js
import { createSlice } from "@reduxjs/toolkit";
import { reportUser, getReports } from "./reportAction";

const initialState = {
  loading: false,
  successMessage: null,
  error: null,
  reports: [], // for admin: all reports
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    clearReportState: (state) => {
      state.loading = false;
      state.successMessage = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Report User
      .addCase(reportUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reportUser.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(reportUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Reports (Admin)
      .addCase(getReports.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReports.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload.data || [];
      })
      .addCase(getReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearReportState } = reportSlice.actions;
export default reportSlice.reducer;
